var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialOtherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29420_36360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6931 5C10.1656 2.55 9.04063 1 8.00013 1C6.95963 1 5.83463 2.55 5.30713 5H10.6931Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8C4.99988 8.6689 5.04448 9.33705 5.1335 10H10.8665C10.9555 9.33705 11.0001 8.6689 11 8C11.0001 7.3311 10.9555 6.66295 10.8665 6H5.1335C5.04448 6.66295 4.99988 7.3311 5 8Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30713 11C5.83463 13.45 6.95963 15 8.00013 15C9.04063 15 10.1656 13.45 10.6931 11H5.30713Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7171 5.00001H14.8671C14.3938 3.92289 13.6746 2.97168 12.7673 2.22268C11.86 1.47368 10.7898 0.947724 9.64258 0.687012C10.5911 1.52151 11.3351 3.06451 11.7171 5.00001Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2265 6H11.8765C11.959 6.66347 12.0002 7.33142 12 8C12 8.66859 11.9586 9.33654 11.876 10H15.226C15.5906 8.6916 15.5911 7.3084 15.2265 6Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64258 15.313C10.79 15.0524 11.8604 14.5265 12.7679 13.7775C13.6754 13.0285 14.3947 12.0772 14.8681 11H11.7181C11.3351 12.9355 10.5911 14.4785 9.64258 15.313Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28281 11H1.13281C1.60621 12.0772 2.3255 13.0285 3.23298 13.7775C4.14046 14.5265 5.21086 15.0524 6.35831 15.313C5.40881 14.4785 4.66481 12.9355 4.28281 11Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35734 0.687012C5.20989 0.947583 4.13948 1.47347 3.232 2.22248C2.32452 2.97149 1.60523 3.92278 1.13184 5.00001H4.28184C4.66484 3.06451 5.40884 1.52151 6.35734 0.687012Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 8C3.9999 7.33141 4.04131 6.66346 4.12396 6H0.773964C0.40933 7.3084 0.40933 8.6916 0.773964 10H4.12396C4.04131 9.33654 3.9999 8.66859 3.99996 8Z",
    fill: "#969BA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29420_36360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialOtherIcon);
export default __webpack_public_path__ + "static/media/Social_OtherIcon.f420db401399a2882ab64ec0a573fff8.svg";
export { ForwardRef as ReactComponent };